import {
  TipoDomandaDTO,
  getGetTipiDomandaQueryOptions,
  getTipiDomanda,
} from '@framework/api-client';
import { AsyncSelectInput, IBaseAsyncSelectInputProps } from '@framework/form';
import React from 'react';

export interface IInquiryTypeSelectInputProps
  extends IBaseAsyncSelectInputProps {
  observations?: boolean | null;
  ids?: string[];
}

export function InquiryTypeSelectInput(props: IInquiryTypeSelectInputProps) {
  const { observations, ids } = props;

  return (
    <AsyncSelectInput
      {...props}
      queryFn={getTipiDomanda}
      queryOptions={getGetTipiDomandaQueryOptions}
      initialParams={{
        ordinamenti: ['titolo'],
        osservazioni: observations ?? undefined,
      }}
      filter={(inquiryType: TipoDomandaDTO) => !ids?.includes(inquiryType.id!)}
      searchByField={'titolo'}
      asOption={(inquiryType: TipoDomandaDTO) => ({
        value: inquiryType.id!,
        label: inquiryType.titolo!,
      })}
    />
  );
}
